<template>
  <div class='SelectIcon'>
    <div class="label-icon">
      {{ label }}
    </div>
    <div class="btn">
      <component
      @click="SetModal({ component: 'SelectIcon', active: true, callback: 'UpdatePrefComp' })"
      :is="icon"
      color="#000000"
      tam="'10px'"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { icons } from '@/components/icons'
export default {
  name: 'SelectIcon',
  components: { ...icons },
  props: ['label', 'icon'],
  methods: {
    ...mapActions(['SetModal'])
  }
}
</script>

<style scoped>
.SelectIcon {
  display: flex;
  align-items: center;
  padding-top: 2%;
  padding-bottom: 1%;
  font-size: 16px;
}

.label-icon {
  width: 91%;
  padding-left: 5px;
  text-align: left;
}

.btn {
  width: 7%;
}
</style>
